import styled from 'styled-components';
import { THEME } from '../../../../themes';

export const InputContainer = styled.div`
  position: relative;
  font-size: 20px;
  margin-top: ${THEME.SPACING.BASE};

  & .input-wrapper {
    height: 32px;
  }
`;
